<template>
    <div id="page">
        <div class="content">
            <div class="info-container">
                <label>{{ $t('optin.info') }}</label>
            </div>
            <div class="optin-container" v-if="(fail === undefined) && !loading">
                <button @click="optIn" type="button"><v-icon name="biking" class="biking" scale="1.4"/> {{ $t('optin.opt-in') }}</button>
            </div>
            <div class="result-container" v-if="fail !== undefined" :class="{ 'error' : this.fail }">
                {{ this.fail ? $t('optin.fail') : $t('optin.success') }}
                <v-icon @click="optIn" name="redo" scale="1.5" class="retry" v-if="fail"/>
            </div>
            <div class="result-container" v-if="loading">
                <div class="spinner"></div>
            </div>
            <div class="user-container">
                <label>{{ this.user }}</label>
            </div>
            <div class="logout-container">
                <button @click="logout" type="button">{{ $t('optin.start-over') }}</button>
            </div>
        </div>
        <Footer />
    </div>
</template>

<script>
import 'vue-awesome/icons/biking'
import 'vue-awesome/icons/redo'

import Footer from '../components/systems/elements/Footer.vue'

import getEnv from '@/utils/env.js'

import axios from 'axios'

export default {
    name: 'OptInPage',
    data() {
        return {
            fail: undefined,
            result: null,
            loading: false
        }
    },
    methods: {
        logout: function() {
            this.$keycloak.logout()
        },
        optIn: function() {
            this.loading = true
            this.fail = undefined
            
            let identifyurl = getEnv('VUE_APP_MIDDLEWARE_URL') + process.env.VUE_APP_NPS_IDENTIFY
            identifyurl += this.usertoken

            axios.get(identifyurl)
            .then((result) => {
                let profileurl = getEnv('VUE_APP_MIDDLEWARE_URL') + process.env.VUE_APP_MIDDLEWARE_NPS_USER_SETTINGS
                profileurl = profileurl.replace('<userid>', result.data.userid)

                const profile = {
                    einstellungsName: process.env.VUE_APP_PROFILE_NAME,
                    einstellungsId: process.env.VUE_APP_PROFILE_ID,
                    einstellungsWerte: [
                        {
                            einstellungsSchuessel: process.env.VUE_APP_PROFILE_KEY
                        }
                    ]
                }

                return axios.post(profileurl, profile)
            })
            .then(() => {
                this.fail = false
                this.loading = false
            })
            .catch(err => {
                console.log(err)
                this.fail = true
                this.loading = false
            })

        }
    },
    computed: {
        user() {
            return this.$keycloak.tokenParsed.email
        },
        usertoken() {
            return this.$keycloak.subject
        }
    },
    components: {
        Footer
    }
}
</script>

<style scoped>
#page {
    height: 100%;
    width: 100%;
}

.content {
    height: calc(100% - 30px);
    display: flex;
    flex-direction: column;
    justify-content: center;
    overflow: hidden;
    overflow-y: auto;
    width: 100%;
    margin: 0 auto;
    padding: 10px 0;
    background: #fff;
}

.info-container {
    width: 90%;
    margin: 0 auto;
}

.info-container > label {
    font-size: 1.5em;
}

.optin-container {
    width: 100%;
    margin-top: 50px;
}

.optin-container > button {
    font-size: 1.5em;
    box-shadow: 0px 1px 10px rgb(100, 100, 150, 0.7);

    /* color: #064a6c; */

    background:#0069B4;
    color: #fff;
    padding-left: 15px;
    padding-right: 15px;
}

.user-container {
    width: 100%;
    margin-top: 50px;
}

.logout-container {
    width: 100%;
}

.logout-container > button {
    color: #0069B4;
    border-radius: 10px;
    padding: 10px;
    margin-top: 15px;
    font-size: 1em;
    box-shadow: 0px 1px 10px rgb(100, 100, 150, 0.7);
}

.logout-container > button:hover {
    background: #00000011;
}

.result-container {
    height: 48px;
    line-height: 48px;
    margin-top: 50px;
    color: green;
    font-weight: bold;
    font-size: 1.5em;
}

.result-container.error {
    color: red;
}

.retry {
    fill: #666;
    display: block;
    margin: 0 auto;
}

.retry:hover {
    cursor: pointer;
    fill: #999;
}

.biking {
    fill: #fff;
    margin-right: 5px;
}

.spinner {
    height: 40px;
    width: 40px;
    border: 5px solid #0069B4;
    border-bottom: 5px solid #0069B466;
    border-radius: 50%;
    animation: spin 1s infinite linear;
    margin: 0 auto;
}

@keyframes spin {
    from {
        transform:rotate(0deg);
    }
    to {
        transform:rotate(360deg);
    }
}

@media(min-width: 501px) {
    .content {
        width: 60%;
        min-width: 500px;
    }

    .info-container {
        width: 70%;
    }
}
</style>